<template>
  <div :class="$style['home-slider']">
    <div :class="$style['home-slider-items']">
      <NuxtErrorBoundary @error="handleBannerError">
        <ClientOnly>
          <Banner />
        </ClientOnly>
      </NuxtErrorBoundary>
      <HomeSliderEvent />
    </div>
  </div>
</template>

<script lang="ts" setup>
import "swiper/scss";
import "swiper/scss/pagination";
import Banner from "~/components/Home/Intro/Banner.vue";
import HomeSliderEvent from "~/components/Home/HomeSlider/HomeSliderEvent.vue";

const handleBannerError = (error: unknown) => {
  console.log("Error message:", (error as Error).message);
};
</script>

<style lang="scss" module>
.home-slider {
  position: relative;
  height: 320px;
  margin-top: 32px;
  margin-bottom: 96px;

  @media screen and (max-width: 834px) {
    margin-bottom: 56px;
  }
  @media screen and (max-width: 800px) {
    height: 606px;
  }
  @media screen and (max-width: 475px) {
    margin-bottom: 64px;
  }
  @media screen and (max-width: 425px) {
    margin-bottom: 20px;
  }
}

.home-slider-items {
  display: flex;
  margin: auto;
  width: 1680px;
  color: var(--general-white);
  gap: 10px;

  @media screen and (max-width: 1900px) {
    max-width: 97.8%;
  }
  @media screen and (max-width: 800px) {
    flex-direction: column;
    width: 100%;
    gap: 12px;
  }
}

.errorFallback {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 320px;
  padding: 20px;
  background: var(--general-background);
  border-radius: 16px;
  border: 1px solid var(--general-stroke);

  p {
    color: var(--functional-red);
    margin-bottom: 16px;
    font-size: 16px;
  }

  button {
    padding: 8px 16px;
    background: var(--button-filled-default);
    color: var(--general-white);
    border: none;
    border-radius: 8px;
    cursor: pointer;

    &:hover {
      background: var(--button-filled-hover);
    }
  }
}
</style>
